import React from 'react'
import ReportingChartRenderer, {
  canRenderReportingChart,
} from 'src/agent/components/ReportingChartRenderer/ReportingChartRenderer'
import type { ReportingChartQuestionContext } from 'src/agent/reporting/chartQuestion.types'
import VisxStackedBarChart from 'src/charting/renderers/visx/VisxStackedBarChart'

import * as style from './ChartQuestionContextCard.style'

export interface ChartQuestionContextCardProps {
  context: ReportingChartQuestionContext
}

const ChartQuestionContextCard: React.FC<ChartQuestionContextCardProps> = ({
  context,
}) => {
  const artifactChartSpec =
    context.source !== 'overview' &&
    canRenderReportingChart(
      context.artifact.chartSpec,
      context.artifact.dataset,
    )
      ? context.artifact.chartSpec
      : undefined

  return (
    <style.Card
      aria-label={`${context.title} chart context`}
      data-testid="reporting-chart-question-context"
      data-reporting-chart-source={context.source}
    >
      <style.Header>
        <style.Title>{context.title}</style.Title>
        <style.Context>{context.contextLabel}</style.Context>
      </style.Header>
      <style.Chart>
        {context.source === 'overview' ? (
          <VisxStackedBarChart
            plan={context.plan}
            currency={context.currency}
            locale="en-US"
            showLegend={false}
          />
        ) : artifactChartSpec ? (
          <ReportingChartRenderer
            chartSpec={artifactChartSpec}
            dataset={context.artifact.dataset}
            presentation="embedded"
            fitToContainer
            showFallbackCaption={false}
          />
        ) : null}
      </style.Chart>
    </style.Card>
  )
}

export default ChartQuestionContextCard
